(function ($) {
	$(window).on('load', function () {
		let pagetop = '#pagetop';
		let footer = '.site-footer';

		$(pagetop).hide();
		$(footer).css('position', 'relative');

		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 500) {
				$(pagetop).slideDown("fast");
			} else {
				$(pagetop).slideUp("fast");
			}
			let scrollHeight = $(document).height();
			let scrollPosition = $(window).height() + $(window).scrollTop();
			let footHeight = $(footer).innerHeight();
			if (scrollHeight - scrollPosition <= footHeight) {
				$(pagetop).css({//フッターに到達したら
					"position": "absolute",
					"bottom": footHeight + 1
				});
			} else { //フッターに到達する前
				$(pagetop).css({
					"position": "fixed",
					// "bottom": "0"
				});
			}
		});
		$(pagetop).on('click', function () {
			$('body,html').animate({
				scrollTop: 0
			}, 400);
			return false;
		});
	});

	// #で始まるアンカーをクリックした場合にスクロール処理
	let headerHeight = $('#masthead').innerHeight(); // ヘッダーの高さ取得
	console.log(headerHeight);

	// ページ読み込み時にハッシュがあればスクロール位置調整
	let urlHash = location.hash; // ハッシュ取得
	if (urlHash) { // ページ外からのページ内スクロールの場合
			$('body,html').stop().scrollTop(0); // 最初にスクロール位置をリセット
			setTimeout(function () {
					let target = $(urlHash);
					if (target.length) {
							let position = target.offset().top - headerHeight; // ヘッダー分調整
							$('body,html').stop().animate({ scrollTop: position }, 500); // スムーズスクロール
					}
			}, 100);
	}

	// アンカーリンクがクリックされた場合の処理
	$('a[href^="#"]').on('click', function(e) {
			e.preventDefault(); // 通常のリンク動作を防止
			let target = $($(this).attr('href')); // クリックされたアンカーのターゲットを取得
			if (target.length) {
					let position = target.offset().top - headerHeight; // ヘッダー分調整
					$('body,html').stop().animate({ scrollTop: position }, 500); // スムーズスクロール
			}
	});

	$('a[href^="#"]:not(a.notscroll)').on('click', function () {
		let href = $(this).attr("href");
		let target = $(href);
		let targetposition = target.offset().top;
		let position = targetposition - headerHeight;
		console.log('ターゲットポジション:' + targetposition);
		console.log('ポジション:' + position);
		$('body,html').stop().animate({ scrollTop: position }, 500);
	});
})(jQuery);
